import * as yup from 'yup';

export const checkAddressCompleteness = async <T>(
  inputFields: string[],
  addressValidator: yup.NotRequiredArraySchema<T>,
) => {
  const addrFieldRegex = /Addr[0-9]/;
  const fieldNamesWithIndex = inputFields.map((a, index) => ({
    index,
    fieldName: a,
  }));
  const addrFields: Record<string, string[]> = {};
  fieldNamesWithIndex.forEach((field) => {
    if (addrFieldRegex.test(field.fieldName)) {
      const addrFieldWithIndex = field.fieldName.split('_')[0];
      addrFields[addrFieldWithIndex] = (
        addrFields[addrFieldWithIndex] || []
      ).concat(field.fieldName);
    }
  });
  return await Promise.all(
    Object.entries(addrFields).map(async ([addrFieldWithIndex, subFields]) => {
      try {
        await addressValidator.validate(subFields);
      } catch (err) {
        return addrFieldWithIndex;
      }
    }),
  ).then((fields) => {
    const incompleteAddrFields = fields.filter((field) => !!field) as string[];
    return incompleteAddrFields.flatMap((field) => addrFields[field] || []);
  });
};
